import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import * as api from '../api/arbitrator';

const namespace = 'LITIGATION';

export const ARBITRATOR_SEARCH_OPTIONS_FETCH_START = `${namespace}/ARBITRATOR_SEARCH_OPTIONS_FETCH_START`;
export const ARBITRATOR_SEARCH_OPTIONS_FETCH_SUCCESS = `${namespace}/ARBITRATOR_SEARCH_OPTIONS_FETCH_SUCCESS`;
export const ARBITRATOR_SEARCH_OPTIONS_FETCH_ERROR = `${namespace}/ARBITRATOR_SEARCH_OPTIONS_FETCH_ERROR`;

export const ARBITRATOR_SEARCH_START = `${namespace}/ARBITRATOR_SEARCH_START`;
export const ARBITRATOR_SEARCH_SUCCESS = `${namespace}/ARBITRATOR_SEARCH_SUCCESS`;
export const ARBITRATOR_SEARCH_ERROR = `${namespace}/ARBITRATOR_SEARCH_ERROR`;

export const ARBITRATOR_FIELDS_FETCH_START = `${namespace}/ARBITRATOR_FIELDS_FETCH_START`;
export const ARBITRATOR_FIELDS_FETCH_SUCCESS = `${namespace}/ARBITRATOR_FIELDS_FETCH_SUCCESS`;
export const ARBITRATOR_FIELDS_FETCH_ERROR = `${namespace}/ARBITRATOR_FIELDS_FETCH_ERROR`;

export const ARBITRATOR_CHANGE_CURRENT_PAGE = `${namespace}/ARBITRATOR_CHANGE_CURRENT_PAGE`;
export const ARBITRATOR_CHANGE_SORT_MODEL = `${namespace}/ARBITRATOR_CHANGE_SORT_MODEL`;
export const ARBITRATOR_CHANGE_PAGE_SIZE = `${namespace}/ARBITRATOR_CHANGE_PAGE_SIZE`;

export const ARBITRATOR_RESET_DATA = `${namespace}/ARBITRATOR_RESET_DATA`;
export const ARBITRATOR_FETCH_START = `${namespace}/ARBITRATOR_FETCH_START`;
export const ARBITRATOR_FETCH_SUCCESS = `${namespace}/ARBITRATOR_FETCH_SUCCESS`;
export const ARBITRATOR_FETCH_ERROR = `${namespace}/ARBITRATOR_FETCH_ERROR`;

export const ARBITRATOR_UPDATE_START = `${namespace}/ARBITRATOR_UPDATE_START`;
export const ARBITRATOR_UPDATE_SUCCESS = `${namespace}/ARBITRATOR_UPDATE_SUCCESS`;
export const ARBITRATOR_UPDATE_ERROR = `${namespace}/ARBITRATOR_UPDATE_ERROR`;

export const ARBITRATOR_DELETE_START = `${namespace}/ARBITRATOR_DELETE_START`;
export const ARBITRATOR_DELETE_SUCCESS = `${namespace}/ARBITRATOR_DELETE_SUCCESS`;
export const ARBITRATOR_DELETE_ERROR = `${namespace}/ARBITRATOR_DELETE_ERROR`;

export const ARBITRATOR_NOTES_FETCH_START = `${namespace}/ARBITRATOR_NOTES_FETCH_START`;
export const ARBITRATOR_NOTES_FETCH_SUCCESS = `${namespace}/ARBITRATOR_NOTES_FETCH_SUCCESS`;
export const ARBITRATOR_NOTES_FETCH_ERROR = `${namespace}/ARBITRATOR_NOTES_FETCH_ERROR`;

export const ARBITRATOR_PROPERTIES_FETCH_START = `${namespace}/ARBITRATOR_PROPERTIES_FETCH_START`;
export const ARBITRATOR_PROPERTIES_FETCH_SUCCESS = `${namespace}/ARBITRATOR_PROPERTIES_FETCH_SUCCESS`;
export const ARBITRATOR_PROPERTIES_FETCH_ERROR = `${namespace}/ARBITRATOR_PROPERTIES_FETCH_ERROR`;

export const ARBITRATOR_NOTE_ADD_START = `${namespace}/ARBITRATOR_NOTE_ADD_START`;
export const ARBITRATOR_NOTE_ADD_SUCCESS = `${namespace}/ARBITRATOR_NOTE_ADD_SUCCESS`;
export const ARBITRATOR_NOTE_ADD_ERROR = `${namespace}/ARBITRATOR_NOTE_ADD_ERROR`;

export const ARBITRATOR_NOTE_UPDATE_START = `${namespace}/ARBITRATOR_NOTE_UPDATE_START`;
export const ARBITRATOR_NOTE_UPDATE_SUCCESS = `${namespace}/ARBITRATOR_NOTE_UPDATE_SUCCESS`;
export const ARBITRATOR_NOTE_UPDATE_ERROR = `${namespace}/ARBITRATOR_NOTE_UPDATE_ERROR`;

export const ARBITRATOR_NOTE_DELETE_START = `${namespace}/ARBITRATOR_NOTE_DELETE_START`;
export const ARBITRATOR_NOTE_DELETE_SUCCESS = `${namespace}/ARBITRATOR_NOTE_DELETE_SUCCESS`;
export const ARBITRATOR_NOTE_DELETE_ERROR = `${namespace}/ARBITRATOR_NOTE_DELETE_ERROR`;

export const ARBITRATOR_VALIDATE_START = `${namespace}/ARBITRATOR_VALIDATE_START`;
export const ARBITRATOR_VALIDATE_SUCCESS = `${namespace}/ARBITRATOR_VALIDATE_SUCCESS`;
export const ARBITRATOR_VALIDATE_ERROR = `${namespace}/ARBITRATOR_VALIDATE_ERROR`;

export const ARBITRATOR_FETCH_PROPERTIES_BY_NAME_START = `${namespace}/ARBITRATOR_FETCH_PROPERTIES_BY_NAME_START`;
export const ARBITRATOR_FETCH_PROPERTIES_BY_NAME_SUCCESS = `${namespace}/ARBITRATOR_FETCH_PROPERTIES_BY_NAME_SUCCESS`;
export const ARBITRATOR_FETCH_PROPERTIES_BY_NAME_ERROR = `${namespace}/ARBITRATOR_FETCH_PROPERTIES_BY_NAME_ERROR`;

export const ARBITRATOR_CREATE = createRequestTypes(
  `${namespace}/ARBITRATOR_CREATE`,
);
export const SET_ACTIVE_ARBITRATOR = `${namespace}/SET_ACTIVE_ARBITRATOR`;
export const setActiveArbitrator = payload => ({
  type: SET_ACTIVE_ARBITRATOR,
  payload,
});
export const RESET_ACTIVE_ARBITRATOR = `${namespace}/RESET_ACTIVE_ARBITRATOR`;
export const resetActiveArbitrator = () => ({ type: RESET_ACTIVE_ARBITRATOR });

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  ARBITRATOR_SEARCH_OPTIONS_FETCH_START,
  ARBITRATOR_SEARCH_OPTIONS_FETCH_SUCCESS,
  ARBITRATOR_SEARCH_OPTIONS_FETCH_ERROR,
);
export const searchArbitrator = makeApiActionCreatorV3(
  api.searchArbitrator,
  ARBITRATOR_SEARCH_START,
  ARBITRATOR_SEARCH_SUCCESS,
  ARBITRATOR_SEARCH_ERROR,
);
export const fetchFields = makeApiActionCreatorV3(
  api.fetchFields,
  ARBITRATOR_FIELDS_FETCH_START,
  ARBITRATOR_FIELDS_FETCH_SUCCESS,
  ARBITRATOR_FIELDS_FETCH_ERROR,
);
export const fetchArbitrator = makeApiActionCreatorV3(
  api.fetchArbitrator,
  ARBITRATOR_FETCH_START,
  ARBITRATOR_FETCH_SUCCESS,
  ARBITRATOR_FETCH_ERROR,
);
export const updateArbitrator = makeApiActionCreatorV3(
  api.updateArbitrator,
  ARBITRATOR_UPDATE_START,
  ARBITRATOR_UPDATE_SUCCESS,
  ARBITRATOR_UPDATE_ERROR,
);
export const deleteArbitrator = makeApiActionCreatorV3(
  api.deleteArbitrator,
  ARBITRATOR_DELETE_START,
  ARBITRATOR_DELETE_SUCCESS,
  ARBITRATOR_DELETE_ERROR,
);
export const createArbitrator = makeApiActionCreatorV3(
  api.createArbitrator,
  ARBITRATOR_CREATE[START],
  ARBITRATOR_CREATE[SUCCESS],
  ARBITRATOR_CREATE[ERROR],
);
export const fetchArbitratorNotes = makeApiActionCreatorV3(
  api.fetchArbitratorNotes,
  ARBITRATOR_NOTES_FETCH_START,
  ARBITRATOR_NOTES_FETCH_SUCCESS,
  ARBITRATOR_NOTES_FETCH_ERROR,
);
export const fetchArbitratorProperties = makeApiActionCreatorV3(
  api.fetchArbitratorProperties,
  ARBITRATOR_PROPERTIES_FETCH_START,
  ARBITRATOR_PROPERTIES_FETCH_SUCCESS,
  ARBITRATOR_PROPERTIES_FETCH_ERROR,
);
export const updateArbitratorNote = makeApiActionCreatorV3(
  api.updateArbitratorNote,
  ARBITRATOR_NOTE_UPDATE_START,
  ARBITRATOR_NOTE_UPDATE_SUCCESS,
  ARBITRATOR_NOTE_UPDATE_ERROR,
);
export const addArbitratorNote = makeApiActionCreatorV3(
  api.addArbitratorNote,
  ARBITRATOR_NOTE_ADD_START,
  ARBITRATOR_NOTE_ADD_SUCCESS,
  ARBITRATOR_NOTE_ADD_ERROR,
);
export const deleteArbitratorNote = makeApiActionCreatorV3(
  api.deleteArbitratorNote,
  ARBITRATOR_NOTE_DELETE_START,
  ARBITRATOR_NOTE_DELETE_SUCCESS,
  ARBITRATOR_NOTE_DELETE_ERROR,
);
export const validateArbitrator = makeApiActionCreatorV3(
  api.validateArbitrator,
  ARBITRATOR_VALIDATE_START,
  ARBITRATOR_VALIDATE_SUCCESS,
  ARBITRATOR_VALIDATE_ERROR,
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: ARBITRATOR_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: ARBITRATOR_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: ARBITRATOR_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetArbitratorData() {
  return async dispatch => {
    dispatch({ type: ARBITRATOR_RESET_DATA });
  };
}

export const arbitratorLookupModalSelectRecords = arbitrators => ({
  type: MODAL_SELECT_ARBITRATOR_RECORDS,
  payload: arbitrators,
});

export const OPEN_ARBITRATOR_LOOKUP_MODAL =
  'LITIGATION/OPEN_ARBITRATOR_LOOKUP_MODAL';
export const CLOSE_ARBITRATOR_LOOKUP_MODAL =
  'LITIGATION/CLOSE_ARBITRATOR_LOOKUP_MODAL';
export const LOOKUP_ARBITRATOR = createRequestTypes(
  'LITIGATION/LOOKUP_ARBITRATOR',
);
export const ARBITRATOR_MODAL_CHANGE_CURRENT_PAGE =
  'LITIGATION/ARBITRATOR_MODAL_CHANGE_CURRENT_PAGE';
export const MODAL_SELECT_ARBITRATOR_RECORDS =
  'LITIGATION/MODAL_SELECT_ARBITRATOR_RECORDS';
export const openArbitratorLookupModal = mode => ({
  type: OPEN_ARBITRATOR_LOOKUP_MODAL,
  payload: mode,
});
export const lookupArbitrator = makeApiActionCreatorV3(
  api.lookupArbitrator,
  LOOKUP_ARBITRATOR[START],
  LOOKUP_ARBITRATOR[SUCCESS],
  LOOKUP_ARBITRATOR[ERROR],
);

export const closeArbitratorLookupModal = () => ({
  type: CLOSE_ARBITRATOR_LOOKUP_MODAL,
});

export const OPEN_ARBITRATOR_CREATE_MODAL = `${namespace}/OPEN_ARBITRATOR_CREATE_MODAL`;
export const CLOSE_ARBITRATOR_CREATE_MODAL = `${namespace}/CLOSE_ARBITRATOR_CREATE_MODAL`;
export const RESET_ARBITRATOR_CREATE_MODAL = `${namespace}/RESET_ARBITRATOR_CREATE_MODAL`;
export const ARBITRATOR_CREATE_MODAL_RESULT = `${namespace}/OWNER_CREATE_MODAL_RESULT`;

export const openArbitratorCreateModal = () => ({
  type: OPEN_ARBITRATOR_CREATE_MODAL,
});

export const closeArbitratorCreateModal = () => ({
  type: CLOSE_ARBITRATOR_CREATE_MODAL,
});

export const resetArbitratorCreateModal = () => ({
  type: RESET_ARBITRATOR_CREATE_MODAL,
});

export const setArbitratorCreateModalResult = result => ({
  type: ARBITRATOR_CREATE_MODAL_RESULT,
  data: result,
});
